export const SET_NOTIFYME_LOADING = 'SET_NOTIFYME_LOADING';

/** @namespace Pwa/Store/NotifyMe/Action/setLoading */
export const setLoading = (isLoading) => ({
    type: SET_NOTIFYME_LOADING,
    isLoading
});
